'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$0024111 from "./presto.-Presto-Router$$anon$111.js";
import * as $j_presto$002e$002dUnknown$002dPage$0024 from "./presto.-Unknown-Page$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$110() {
  this.bfg = null;
  this.bf8 = null;
  this.bf9 = false;
  this.bfh = null;
  this.bfi = false;
  this.bfl = null;
  this.bfe = null;
  this.bff = false;
  this.bfa = null;
  this.bfb = false;
  this.bfc = null;
  this.bfd = false;
  this.bfj = false;
  this.bfk = false;
  this.bfg = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bfl = "UnknownPage";
}
export { $c_Lpresto_PrestoRouter$$anon$110 as $c_Lpresto_PrestoRouter$$anon$110 };
$p = $c_Lpresto_PrestoRouter$$anon$110.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$110;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$110() {
}
export { $h_Lpresto_PrestoRouter$$anon$110 as $h_Lpresto_PrestoRouter$$anon$110 };
$h_Lpresto_PrestoRouter$$anon$110.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.bfg;
});
$p.M = (function() {
  if ((!this.bf9)) {
    this.bf8 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bf9 = true;
  }
  return this.bf8;
});
$p.O = (function() {
  if ((!this.bfi)) {
    this.bfh = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bfi = true;
  }
  return this.bfh;
});
$p.D = (function() {
  return this.bfl;
});
$p.t = (function() {
  if ((!this.bff)) {
    this.bfe = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("str", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bff = true;
  }
  return this.bfe;
});
$p.N = (function() {
  if ((!this.bfb)) {
    this.bfa = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bfb = true;
  }
  return this.bfa;
});
$p.Q = (function() {
  if ((!this.bfd)) {
    this.bfc = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$0024111.$c_Lpresto_PrestoRouter$$anon$111();
    this.bfd = true;
  }
  return this.bfc;
});
$p.v = (function() {
  if ((!this.bfk)) {
    this.bfj = false;
    this.bfk = true;
  }
  return this.bfj;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee658) => ((p) => \u03b4scrutinee658.cHd(p)))($j_presto$002e$002dUnknown$002dPage$0024.$m_Lpresto_UnknownPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$110 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$110, "presto.PrestoRouter$$anon$110", ({
  NH: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$110 as $d_Lpresto_PrestoRouter$$anon$110 };
//# sourceMappingURL=presto.-Presto-Router$$anon$110.js.map
